// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-expired-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.session-expired-modal {
  background: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.session-expired-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.session-expired-modal h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #1a1a1a;
}

.session-expired-modal p {
  font-size: 16px;
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.session-expired-login-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
}
.session-expired-login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}
.session-expired-login-button:active {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/components/SessionExpiredModal/SessionExpiredModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kCAAA;UAAA,0BAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,0CAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,4BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,WAAA;AAAF;AAEE;EACE,2BAAA;EACA,+CAAA;AAAJ;AAGE;EACE,wBAAA;AADJ","sourcesContent":[".session-expired-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  backdrop-filter: blur(4px);\n}\n\n.session-expired-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 32px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.session-expired-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.session-expired-modal h2 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  color: #1a1a1a;\n}\n\n.session-expired-modal p {\n  font-size: 16px;\n  color: #666;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.session-expired-login-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 32px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  width: 100%;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
